import Button from 'react-bootstrap/esm/Button';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import { Link, useParams } from 'react-router-dom';
import DisplayGoalDetail from './DisplayGoalDetail';

type RouteGoalDetailParams = {
  goalID: string;
}

const RouteGoalDetail = () => {
  let { goalID } = useParams<keyof RouteGoalDetailParams>() as RouteGoalDetailParams;
  return (
    <>
      <Row className="justify-content-end">
        <Col sm="auto">
          <Link to={`/goal/${goalID}/edit`}>
            <Button>Edit</Button>
          </Link>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <DisplayGoalDetail goalID={goalID} />
        </Col>
      </Row>
    </>
  );
};

export default RouteGoalDetail;
